import "./LeavePage.css";

const LeavePage = () => {
  const onLeaveClicked = () => {
    // do something
    console.log("Leave clicked");
  };

  const onCancelClicked = () => {
    // do something
    console.log("Cancel clicked");
  };
  return (
    <div className="leave-page-container">
      <div className="leave-page-content">
        <p className="leave-page-heading">
          Are you sure you want to leave this page?
        </p>
        <p className="leave-page-subheading">
          Your progress will not be saved. Lorem Ipsum
        </p>
        <div className="leave-page-button-container">
          <div
            className="leave-page-button"
            style={{ border: "2px solid #18283c" }}
            onClick={() => onLeaveClicked()}
          >
            <p>Yes, leave</p>
          </div>
          <div
            className="leave-page-button"
            style={{
              backgroundColor: "#e97700",
              color: "white",
              border: "2px solid #e97700",
            }}
            onClick={() => onCancelClicked()}
          >
            <p>Cancel</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeavePage;
